import React, { useEffect } from 'react'
import images from '../images/images'
import './FailedUpdatePackage.scss'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import { isBrowser, isMobileOnly } from 'react-device-detect';
import { setUpdatedSocResultStatus, resetAddedExtendedPackageResult, setChosenSocForAction } from '../../cellcomAbroadBlockSlice'
import { connect } from 'react-redux';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../../animations/paperPlane.json';
import PisaTower from '../../../../../animations/fallingTower.json';
import Image from 'app/Components/Shared/Image/image';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';

function FailedUpdatePackage({ onClose, setUpdatedSocResultStatus, cancelPopUpText, resetAddedExtendedPackageResult, setChosenSocForAction }) {

    function goBack() {
        setUpdatedSocResultStatus(null)
        setChosenSocForAction(null)
        onClose();
    }

    const cancelPopUpTxt = cancelPopUpText ? reverseStarSymbol(cancelPopUpText) : "";

    function reverseStarSymbol(txt) {
        if(txt.includes("*"+ window.Config.technicalSupportPhone)) {
            return txt.replace("*"+ window.Config.technicalSupportPhone, "*"+ window.Config.technicalSupportPhone)
        } else {
            return txt;
        }
    }

    useEffect(() => {
        gaEvent(gaParams.ABROAD_MY_ABROAD_SHOW_FAILED_INSTALL_PACKAGE_POP_UP.category,
                gaParams.ABROAD_MY_ABROAD_SHOW_FAILED_INSTALL_PACKAGE_POP_UP.eventType,
                gaParams.ABROAD_MY_ABROAD_SHOW_FAILED_INSTALL_PACKAGE_POP_UP.eventParams)
        return () => {
            setUpdatedSocResultStatus(null)
            resetAddedExtendedPackageResult(null)
            setChosenSocForAction(null)
        }
    },[])

    return (
        <div className="failed-update-package-container">
            {!cancelPopUpText ? <div className="header">מוזר, יש כאן תקלה</div> : <div className="header">רגע, יש כאן עניין</div>}
            {!cancelPopUpText ? <ThemedLottie animationData={PisaTower}  color={ThemeColorEnum.PRIMARY} loop={false} width={isMobileOnly ? 80 : 125} /> : <ThemedLottie animationData={PaperPlane}  color={ThemeColorEnum.PRIMARY} loop={false} width={isMobileOnly ? 200 : 250} />}
            {!cancelPopUpText ? 
            <p className="p-main">
                <span className="strong">לא הצלחנו להתקין את החבילה</span>
                <br />
                <span>אל דאגה, צוות המומחים שלנו זמין <br />כדי לטפל בכל בעיה</span>
            </p> 
            :
            <p className="p-main">
                <span dangerouslySetInnerHTML={{__html: cancelPopUpTxt}}></span>
            </p>}
            <div className="contact-box">
                <span className="txt-header">זמינים לכל שאלה 24/7<br />שיחת חינם מהארץ ומחו"ל</span>
                <div className="under-box">
                    <Image className="phone-img" src={images.phoneCall} alt="phone"/>
                    <span className="txt">{window.Config.numberCallCenterAbroad}</span>
                </div>
            </div>
            {isBrowser && !cancelPopUpText && <BtnSubmit text="סיום" onclick={() => goBack()}/>}
        </div>
    )
}

const mapStateToProps = (state) => ({

});


const mapDispatchToProps = {
    setUpdatedSocResultStatus,
    resetAddedExtendedPackageResult,
    setChosenSocForAction
};

export default connect(null, mapDispatchToProps)(FailedUpdatePackage);